<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          DYNAMIC APPROVAL
        </h2>
        <v-breadcrumbs
          class="px-0 text-capitalize"
          :items="breadcrumbs"
        ></v-breadcrumbs>
      </v-flex>
      <v-spacer />
      <v-card class="dynamic">
        <v-card-title>
          <v-flex xs9 class="pl-1 text-capitalize">
            {{ title }}
          </v-flex>
          <v-spacer />
          <v-col cols="auto" class="text-right" v-if="isDetail || isEdit">
            <v-icon title="refresh" @click="trigger = !trigger">
              refresh
            </v-icon>
          </v-col>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-layout row wrap>
            <v-flex xs9 class="pa-0 form-hierarchy">
              <v-flex xs10 class="pr-0 py-0">
                <v-row>
                  <v-col cols="9" class="py-0">
                    <ValidationProvider
                      name="Division"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="darkblue--text">Division</label>
                      <v-autocomplete
                        id="division"
                        single-line
                        outlined
                        dense
                        placeholder="Division"
                        v-model="items.division_id"
                        :items="itemsDiv"
                        required
                        :error-messages="errors"
                        disabled
                        item-value="id"
                        item-text="name"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-flex>
            </v-flex>
            <dynamic-form
              :node="items"
              :isEdit="isEdit"
              :isDetail="isDetail"
              :triggerGetData="trigger"
              class="ml-3"
            />
          </v-layout>
        </v-card-text>
        <v-card-actions class="text-right pa-5 pt-0">
          <v-spacer></v-spacer>
          <v-flex xs2 right>
            <v-btn
              id="btn-cancel"
              dark
              rounded
              color="red"
              block
              @click="goBack()"
            >
              {{ id === 'id' ? 'Cancel' : 'Back' }}
            </v-btn>
          </v-flex>
          <!-- <v-flex xs2 right v-if="!isDetail" class="ml-4">
            <v-btn
              id="btn-save"
              dark
              rounded
              color="blue darken-3"
              block
              @click="saveConfirm('draft')"
            >
              Save As Draft
            </v-btn>
          </v-flex>
          <v-flex xs2 right v-if="!isDetail" class="ml-4">
            <v-btn
              id="btn-save"
              dark
              rounded
              color="primary"
              block
              @click="saveConfirm('apply')"
            >
              Apply
            </v-btn>
          </v-flex> -->
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import dynamicForm from '../../../components/dynamicHierarchy/approval.vue';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'dynamic-form': dynamicForm
  },
  props: ['type', 'id'],
  data() {
    return {
      itemsDiv: [],
      items: {
        division_id: '',
        group: []
      },
      baseUrl: process.env.VUE_APP_BASE_URL,
      loading: false,
      progressDialogLoading: false,
      isDetail: false,
      isEdit: false,
      breadcrumbs: [
        {
          text: 'Organization Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Dynamic Approval List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text:
            this.type === 'detail'
              ? 'Dynamic Approval Details'
              : this.type === 'edit'
              ? 'Edit Dynamic Approval'
              : 'Create Dynamic Approval',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      divisi: {},
      trigger: false
    };
  },
  async mounted() {
    this.isDetail = this.type === 'detail' ? true : false;
    this.isEdit = this.type === 'edit' ? true : false;
    await this.getDivision();
    if (this.isDetail || this.isEdit) {
      this.items.division_id = this.id;
    }
  },
  watch: {
    items: {
      handler: function(val) {
        return val;
      },
      deep: true
    }
  },
  computed: {
    title() {
      let name = '';
      switch (this.type) {
        case 'create':
          name = 'Create Dynamic Approval';
          break;
        case 'detail':
          name = 'Dynamic Approval Details';
          break;
        case 'edit':
          name = 'Edit Dynamic Approval';
          break;
      }
      return name;
    }
  },
  methods: {
    getDivision() {
      return this.$store
        .dispatch('division/getAll', {
          paginate: false
        })
        .then(data => {
          if (data.code === 200) {
            this.itemsDiv = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push({
        name: this.isDraft ? 'draft-hierarchy' : 'dynamic-approval'
      });
    }
  }
};
</script>
<style>
.icon-medium {
  font-size: 25px !important;
}
.preview-hierarchy .orgchart-container {
  position: sticky;
  top: 85px;
}
.form-hierarchy {
  /* overflow: auto; */
}
</style>
